import React from 'react';

import { Accordion, AccordionHeader, AccordionBody } from '@hpstellar/core/visId';
import SpecsList from './specs-list';

export default ({ expanded, setExpanded, specs, title = 'Specifications' }) => {
    if (!specs || specs.length < 1) {
        return null;
    }
    return (
        <div id="quickViewFooter">
            <Accordion expanded={expanded} onChange={setExpanded} className="specsModal" borderPosition="bottom" horizontalSpacing="l">
                <AccordionHeader aria-controls="accordionContent" id="accordionHeder" tag="span" title={title} />
                <AccordionBody>
                    <SpecsList specs={specs} delimeter=" | " isCaps />
                </AccordionBody>
            </Accordion>
        </div>
    );
};
